import React from 'react';
import { useAuth } from '@/context/AuthContext';
import { useTranslation } from 'react-i18next';
import './DashboardPage.css';

export const DashboardPage: React.FC = () => {
  const { user } = useAuth();
  const { t } = useTranslation();

  return (
    <div className="dashboard-protected-message">
      <div className="dashboard-lock-icon">🔒</div>
      <h1 className="dashboard-title">Protected Area</h1>
      <p className="dashboard-subtitle">
        {t('dashboard.welcomeBack')}, {user?.first_name || user?.username}
      </p>
    </div>
  );
};
